import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from 'src/app/auth/storage.service';
import { resolveExternalRedirectHost } from './external-redirect.config';

@Injectable({
  providedIn: 'root'
})
export class ExternalRedirectGuardGuard implements CanActivate {

  constructor(private storage: StorageService) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const sessiontoken = sessionStorage.getItem('onhibernate') === 'true'
      ? sessionStorage.getItem('access-token')
      : this.storage.getItem('access-token', false);

    const host = resolveExternalRedirectHost(state.url, window.location.origin);
    if (!host) {
      return true;
    }

    const tokenParam = sessiontoken
      ? `?token=${encodeURIComponent(sessiontoken)}`
      : '';
    window.location.href = `${host}${state.url}${tokenParam}`;
    return false;
  }
}
